module.exports = __webpack_public_path__ + "img/1569440566.cb4dbd49.jpg";